"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const border_1 = require("./variables/border");
const brand_1 = require("./variables/brand");
const breakpoints_1 = require("./variables/breakpoints");
const feedbackColor_1 = require("./variables/feedbackColor");
const font_1 = require("./variables/font");
const line_1 = require("./variables/line");
const neutralColor_1 = require("./variables/neutralColor");
const opacity_1 = require("./variables/opacity");
const shadow_1 = require("./variables/shadow");
const spacing_1 = require("./variables/spacing");
const utils_1 = require("./variables/utils");
tslib_1.__exportStar(require("./types"), exports);
function createTokens(brand) {
    return {
        spacing: spacing_1.spacing,
        border: border_1.border,
        brandColor: (0, brand_1.createBrandColors)(brand),
        breakpoints: Object.assign(Object.assign({}, breakpoints_1.breakpoints), breakpoints_1.breakpoinstUtils),
        feedbackColor: feedbackColor_1.feedbackColor,
        font: font_1.font,
        line: line_1.line,
        neutralColor: neutralColor_1.neutralColor,
        opacity: opacity_1.opacity,
        shadow: shadow_1.shadow,
        pxToRem: utils_1.pxToRem,
        remToPx: utils_1.remToPx,
        hexToRgba: utils_1.hexToRgba
    };
}
exports.default = createTokens;
